export default __webpack_public_path__ + "static/media/PPI-patio-030.8e5486d7.jpg";